<template>
    <div class="header v-flex primary white--text">
        <div style="margin-top: 2px;">
            <a
                v-if="usefilter"
                @click="onFilter"
                class="pl-4"
            >
                <i class="fas fa-filter white--text mr-1"></i>
                <i class="fas white--text" :class="open ? 'fa-caret-up' : 'fa-caret-down'"></i>
            </a>
            <a
                v-if   = "usetoggle"
                @click = "onToggle"
                class  = "ml-3"
            >
                <i :class="toggle ? 'fas' : 'far'" class=" fa-square white--text mr-1"></i>
            </a>
        </div>
        <v-spacer />
        <div>
            <div class="header-title v-flex" :class="subtitle ? 'header-title-subtitle' : ''">
                <a v-if="right" @click="onArrow">
                    <v-icon class="header-arrow mr-2">
                        mdi-arrow-left-bold
                    </v-icon>
                </a>
                <div>
                    {{ title }}
                </div>
                <a v-if="!right" @click="onArrow">
                    <v-icon class="header-arrow ml-2">
                        mdi-arrow-right-bold
                    </v-icon>
                </a>
            </div>
            <div v-if="subtitle" class="header-subtitle">
                {{ subtitle }}
            </div>
        </div>
        <v-spacer />
        <slot name="toolbar" />
        <div>
            <a class="fas fa-times white--text pr-6 pl-2" @click="onClose"></a>
        </div>
    </div>
</template>

<script>
export default {
    name: "CDrawerHeader",

    data: () => ({
        open    : false,
        toggle  : false,
        site    : null,
        incident: null,
        right: true
    }),

    props: {
        title: {
            required: true
        },
        subtitle: {
            required: false,
            type: String
        },
        icon: {
            type: String
        },
        usefilter: {
            type: Boolean
        },
        usetoggle: {
            type: Boolean
        },
    },

    methods: {
        onArrow () {
            this.right = !this.right;
            this.$emit("arrow", this.right)
        },

        onClose () {
            this.$emit("close");
        },

        onFilter () {
            this.open = !this.open;
            this.$emit("filter", this.filter);
        },

        onToggle () {
            this.toggle = !this.toggle;
            this.$emit("toggle", this.toggle);
        }
    }
}
</script>

<style scoped>

.header {
    height: 47px;
    padding-left: 0;
    padding-top: 4px;
    line-height: 40px;
    text-decoration: none;
    text-align: center;
}

.header-title {
    font-size: 18px!important;
    font-weight: 900!important;
}

.header-arrow {
    font-size: 25px!important;
    color: white;
}

.header-title-subtitle {
    margin-top: -9px;
}

.header-subtitle {
    font-size: 15px!important;
    font-weight: normal!important;
    margin-top: -20px;
}

</style>